// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3SYsS","name":"ConsentHeader_name__GZSRG","birthday":"ConsentHeader_birthday__3RZAb","skeleton":"ConsentHeader_skeleton__8ZbI0"};